import { useHead } from "@vueuse/head";

export function useMeta() {
  const updateMeta = (meta) => {
    useHead({
      title: meta.title,
      meta: [
        {
          name: "description",
          content: meta.description,
        },
        {
          property: "og:title",
          content: meta.ogTitle,
        },
        {
          property: "og:description",
          content: meta.ogDescription,
        },
        {
          property: "og:image",
          content: meta.ogImage,
        },
        {
          property: "og:type",
          content: meta.ogType,
        },
        ...(meta.ogUrl
          ? [
              {
                property: "og:url",
                content: meta.ogUrl,
              },
            ]
          : []),
        ...(meta.ogSiteName
          ? [
              {
                property: "og:site_name",
                content: meta.ogSiteName,
              },
            ]
          : []),
        {
          name: "twitter:card",
          content: meta.twitterCard,
        },
        {
          name: "twitter:title",
          content: meta.twitterTitle,
        },
        {
          name: "twitter:description",
          content: meta.twitterDescription,
        },
        {
          name: "twitter:image",
          content: meta.twitterImage,
        },
      ],
    });
  };

  return {
    updateMeta,
  };
}
